<!--
 * @FileDescription: 已出账期
 * @Author: 陈文景
 * @Date: 2022-12-29 14:31:12
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="issued">
    <div :class="['header', { margin: !multipleSelection.length }]">
      <el-select v-model="parameter.paymentStatusList" multiple collapse-tags clearable size="medium" :placeholder="$t('Billing.Issued.Status')" @change="getIssuedBillsList">
        <el-option :label="$t('Billing.Issued.WaitingPayment')" :value="0" />
        <el-option :label="$t('Billing.Issued.PaymentProcessing')" :value="1" />
        <el-option :label="$t('Billing.Issued.Paid')" :value="2" />
      </el-select>

      <el-date-picker v-model="parameter.dateTime" align="center" size="medium" type="datetimerange" range-separator="-" :start-placeholder="$t('Billing.Issued.StartDate')" :end-placeholder="$t('Billing.Issued.EndDate')" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="changeDatePicker" />

      <BatchSearchOne @clear="handleClearBatchSearchOne" @search="handleSearchBatchSearchOne" />
    </div>

    <div v-if="multipleSelection.length" class="batch-tips">
      <span class="tips">
        <span class="sum">{{ multipleSelection.length }}</span>
        <span class="text">{{ $t('Billing.Issued.Selected') }}</span>
      </span>
      <span class="pay-now" @click="batchPayNow">{{ $t('Billing.Issued.PayNow') }}</span>
    </div>

    <el-table v-loading="loading" ref="table" :data="bills" row-key="id" :style="{ width: '100%' }" :height="`calc(100% - ${ multipleSelection.length ? '146px' : '98px' })`" @selection-change="handleSelectionChange" @sort-change="onTableSortChange">
      <el-table-column v-if="bills.length" type="selection" align="center" width="50" :selectable="selectable" />
      <el-table-column :label="$t('Billing.Issued.ID')" show-overflow-tooltip>
        <template v-slot="{ row }">
          {{ defaultTips(row.billId) }}
        </template>
      </el-table-column>
      <el-table-column prop="amount" :label="$t('Billing.Issued.BillsAmount')" show-overflow-tooltip sortable="custom">
        <template v-slot="{ row }">
          {{ amount(row.amount) }}
        </template>
      </el-table-column>
      <el-table-column prop="paidAmount" :label="$t('Billing.Issued.PaymentAmount')" show-overflow-tooltip sortable="custom">
        <template v-slot="{ row }">
          {{ paidAmount(row.paidAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="paymentStatus" :label="$t('Billing.Issued.TableColumnStatus')" width="170">
        <template v-slot="{ row }">
          <Status v-if="row.paymentStatus === 0" :text="$t('Billing.Issued.WaitingPayment')" orange />
          <Status v-else-if="row.paymentStatus === 1" :text="$t('Billing.Issued.PaymentProcessing')" purple />
          <Status v-else-if="row.paymentStatus === 2" :text="$t('Billing.Issued.Paid')" green />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="paymentDate" :label="$t('Billing.Issued.PaymentDate')" show-overflow-tooltip sortable="custom">
        <template v-slot="{ row }">
          {{ defaultTips(formatTimeStamp(row.paymentDate)) }}
        </template>
      </el-table-column>
      <el-table-column prop="createDate" :label="$t('Billing.Issued.CreateDate')" show-overflow-tooltip sortable="custom">
        <template v-slot="{ row }">
          {{ defaultTips(formatTimeStamp(row.createDate)) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('Billing.Issued.Action')" align="center" width="140">
        <template v-slot="{ row }">
          <p class="details" @click="() => handleViewDetails(row)">{{ $t('Billing.Issued.ViewDetails') }}</p>
          <el-button v-if="row.paymentStatus === 0" :disabled="multipleSelection.length > 0" type="primary" size="medium" round @click="() => handlePayNow(row)">{{ $t('Billing.Issued.TableColumnPayNow') }}</el-button>
        </template>
      </el-table-column>

      <div slot="empty" class="not-data">
        <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
        <div class="tips-text">{{ $t('Billing.Issued.NoRecord') }}</div>
      </div>
    </el-table>
    <div class="footer">
      <el-pagination :current-page.sync="parameter.pageNumber" :page-sizes="[20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="currentChange" />
    </div>

    <!-- 详情对话框 -->
    <IssuedDetailsDialog ref="issuedDetailsDialog" />

    <!-- 支付对话框 -->
    <PaymentDialog ref="paymentDialog" @update="getIssuedBillsList" />
  </div>
</template>

<script>
import API from '@/api'
import Status from './Status.vue'
import { formatTimeStamp } from '@/util/moment'
import PaymentDialog from './PaymentDialog.vue'
import BatchSearchOne from './BatchSearchOne.vue'
import IssuedDetailsDialog from './IssuedDetailsDialog.vue'

let parameter = {
  paymentStatusList: [], // 支付状态：-2.支付失败 0.待付款 1.付款中 2.已付款
  dateTime: null, // 时间选择器双向绑定的值(请求前需删除该字段)
  createDateStart: null, // 创建时间查询开始
  createDateEnd: null, // 创建时间查询
  billIds: [], // 账单ID数组
  sortType: undefined, // 排序类型: 1.应收款 2.已收款 3.账单支付时间 4.创建时间(为空则按更新时间降序)
  sort: undefined, // 升降序排序: asc.升序 desc.降序
  pageNumber: 1,
  pageSize: 20
}

export default {
  components: {
    Status,
    PaymentDialog,
    BatchSearchOne,
    IssuedDetailsDialog
  },
  data() {
    return {
      formatTimeStamp,

      parameter: { ...parameter },

      bills: [],
      total: 0,
      loading: false,
      multipleSelection: [] // 当前选中的行数据
    }
  },
  computed: {
    amount() {
      return (value) => {
        return value ? `US$${value}` : '-'
      }
    },
    paidAmount() {
      return (value) => {
        return value ? `US$${value}` : '-'
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  created() {
    // this.getIssuedBillsList()
  },
  methods: {
    /**
     * API 获取已出账单列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getIssuedBillsList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let parameter = { ...this.parameter }
        delete parameter.dateTime
        let { data } = await API.getIssuedBillsList(parameter)
        this.bills = data.list
        this.total = data.total
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 对Table进行重新布局(解决表格抖动问题)
     */
    doLayoutTable() {
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },

    /**
     * 时间日期选择器的回调事件
     *
     * @param {Array} date 日期数组
     */
    changeDatePicker(date) {
      if (date && date.length === 2) {
        this.parameter.createDateStart = date[0]
        this.parameter.createDateEnd = date[1]
      } else {
        this.parameter.createDateStart = undefined
        this.parameter.createDateEnd = undefined
      }
      this.getIssuedBillsList()
    },

    /**
     * 批量搜索清除内容的回调事件
     */
    handleClearBatchSearchOne() {
      this.parameter.billIds = []
      this.getIssuedBillsList()
    },

    /**
     * 批量搜索的回调事件
     *
     * @param {String} value 搜索关键字
     */
    handleSearchBatchSearchOne(value) {
      let result = value && value.split(',')
      if (result && result.length) {
        this.parameter.billIds = result
      }
      this.getIssuedBillsList()
    },

    /**
     * 返回值用来决定这一行的CheckBox是否可以被勾选
     *
     * @param {Object} row 当前行对象
     */
    selectable(row) {
      return row.paymentStatus === 0
    },

    /**
     * 表格多选框的回调事件
     */
    handleSelectionChange(value) {
      this.multipleSelection = value
    },

    /**
     * 当表格的排序条件发生变化的时候会触发该事件
     *
     * @param {Object} value 排序对象
     */
    onTableSortChange({ prop, order }) {
      if (order) {
        this.parameter.sortType = prop === 'amount' ? 1 : prop === 'paidAmount' ? 2 : prop === 'paymentDate' ? 3 : prop === 'createDate' ? 4 : undefined
        this.parameter.sort = order ? (order === 'ascending' ? 'asc' : 'desc') : undefined
      } else {
        this.parameter.sortType = undefined
        this.parameter.sort = undefined
      }
      this.getIssuedBillsList()
    },

    /**
     * 查看详情
     *
     * @param {Object} row 当前点击的行数据
     */
    handleViewDetails(row) {
      this.$refs.issuedDetailsDialog.show(row)
    },

    /**
     * 支付
     *
     * @param {Object} row 当前点击的行数据
     */
    handlePayNow(row) {
      this.$refs.paymentDialog.show(row, 1)
    },

    /**
     * 批量支付
     */
    batchPayNow() {
      this.$refs.paymentDialog.show(this.multipleSelection, 2)
    },

    /**
     * 每页显示数量发生改变时的回调
     *
     * @param size 每页显示数量
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getIssuedBillsList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getIssuedBillsList(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.issued {
  width: 100%;
  height: 100%;

  .header {
    &.margin {
      margin-bottom: 15px;
    }
    .el-select {
      width: 238px;
      /deep/.el-input__inner {
        border-radius: 2px;
      }
    }

    .el-date-editor {
      width: 347px;
      margin: 0 12px;
    }

    .el-input__inner {
      border-radius: 2px;
    }
  }

  .batch-tips {
    height: 53px;
    margin: 5px 0;
    line-height: 53px;
    .tips {
      .sum {
        color: #99c41c;
      }
      .text {
        margin-left: 5px;
      }
    }
    .pay-now {
      display: inline-block;
      height: 36px;
      color: #99c41c;
      line-height: 36px;
      text-align: center;
      padding: 0 12px;
      margin-left: 36px;
      border-radius: 18px;
      user-select: none;
      cursor: pointer;
      background-color: rgba(235, 243, 210, 0.37);
    }
  }

  .details {
    cursor: pointer;
    &:hover {
      color: #99c41c;
    }
  }

  .not-data {
    padding: 28px 0;
    .tips-text {
      color: #747a87;
      font-size: 16px;
      line-height: 24px;
    }
  }

  .footer {
    margin-top: 15px;
    text-align: end;
    /deep/.el-input__inner {
      border-radius: 2px;
    }
  }
}
</style>
